import React, { Component } from "react";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

import "./SystemSpecHistory.component.scss";
import { HallsActionCreators } from "../../../actions/actionCreators";
import { ActionCreator } from "../../../../../actions/actions";
import { hallsStoreSelectors } from "../../../store/store";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { formatDateText } from "../../../../../utils/utils";
import UserAvatar from "../../../../home/components/Topbar/LoggedInUser/UserAvatar/UserAvatar.component";

export interface SystemSpecHistoryProps extends RouteComponentProps {
    getSpecificationActivity: ActionCreator;
    serverId: number;
    specificationActivitiesLoading: boolean;
    specificationActivities: any[];
    specificationActivitiesPage: number;
    showDetail: any;
}

const PAGE_SIZE = 12;

class SystemSpecHistory extends Component<SystemSpecHistoryProps, {}> {
    constructor(props) {
        super(props);

        this.props.getSpecificationActivity({
            serverId: this.props.serverId,
            page: 0,
            top: PAGE_SIZE
        });
    }

    renderDayActivities = activity => {
        const operationTime = new Date(activity.inserted_at)
            .toTimeString()
            .split(" ")[0];

        return (
            <li key={`${activity.id}`} className="spec-history-item">
                {/*<div className="user-photo">
                    <UserAvatar
                        email={"users@fabamaq.com"}
                        size={28}
                    />
        </div>*/}
                <div className="spec-info">
                    <div>
                        {`Config V ${activity["specs"]["config_version"] ? activity["specs"]["config_version"] : 'N/A'}`}{" "}
                        {this.props.specificationActivities["currentSpec"]["specs"]["Server"] &&
                        this.props.specificationActivities["currentSpec"]["specs"]["Server"]["pendingConfigVersion"] !== 0
                            ? `(P. ${activity["specs"]["Server"] ? 'V' + activity["specs"]["Server"]["pendingConfigVersion"] : ''})`
                            : ''}{" "}
                        | SS {activity["specs"]["Server"] ? activity["specs"]["Server"]["version"] : 'N/A'}
                    </div>
                    <div>
                        <div className="info">
                            {/*<span>User</span>*/}
                            <div className="spec-date">@ {operationTime}</div>
                        </div>
                    </div>
                    <button
                        className="red-btn"
                        onClick={() => this.props.showDetail(activity)}
                    >
                        <i className="icon-file-text"></i>
                        Details
                    </button>
                </div>
            </li>
        );
    };

    renderDay = (key, day) => {
        return (
            <div key={key} className="activity-day">
                <p>{formatDateText(key, "short", true, true, true)}</p>
                <ul>
                    {_.orderBy(day, ["inserted_at"], ["desc"]).map(activity =>
                        this.renderDayActivities(activity)
                    )}
                </ul>
            </div>
        );
    };

    render() {
        return (
            <div className="panel-specification-history">
                <div>
                    <h1>Specification History</h1>
                    <div
                        className={`${
                            this.props.specificationActivitiesLoading ||
                            !this.props.specificationActivities["activities"] ||
                            this.props.specificationActivities["activities"]
                                .length == 0
                                ? "loading"
                                : ""
                        }`}
                    >
                        {this.props.specificationActivitiesLoading &&
                            (!this.props.specificationActivities[
                                "activities"
                            ] ||
                                Object.keys(
                                    this.props.specificationActivities[
                                        "activities"
                                    ]
                                ).length == 0) && (
                                <Components.LoadingRipple
                                    width={100}
                                    height={100}
                                />
                            )}
                        {!this.props.specificationActivitiesLoading &&
                            (!this.props.specificationActivities[
                                "activities"
                            ] ||
                                Object.keys(
                                    this.props.specificationActivities[
                                        "activities"
                                    ]
                                ).length == 0) && (
                                <p className="no-spec-history">
                                    No system specifications to show.
                                </p>
                            )}

                        {this.props.specificationActivities["activities"] &&
                            Object.keys(
                                this.props.specificationActivities["activities"]
                            ).length > 0 && (
                                <div>
                                    {Object.keys(
                                        this.props.specificationActivities[
                                            "activities"
                                        ]
                                    ).map(key => {
                                        return this.renderDay(
                                            key,
                                            this.props.specificationActivities[
                                                "activities"
                                            ][key]
                                        );
                                    })}

                                    {!this.props
                                        .specificationActivitiesLoading &&
                                        !this.props.specificationActivities[
                                            "finished"
                                        ] && (
                                            <div className="load-more">
                                                <button
                                                    onClick={() => {
                                                        this.props.getSpecificationActivity(
                                                            {
                                                                serverId:
                                                                    this.props
                                                                        .serverId,
                                                                page:
                                                                    this.props
                                                                        .specificationActivitiesPage +
                                                                    1,
                                                                top: PAGE_SIZE
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Load more
                                                </button>
                                            </div>
                                        )}
                                    {this.props
                                        .specificationActivitiesLoading &&
                                        !this.props
                                            .specificationActivitiesLoading[
                                            "finished"
                                        ] && (
                                            <div className="load-more">
                                                Loading...
                                            </div>
                                        )}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    specificationActivities: hallsStoreSelectors.specificationActivities(state),
    specificationActivitiesLoading:
        hallsStoreSelectors.specificationActivitiesLoading(state),
    specificationActivitiesPage:
        hallsStoreSelectors.specificationActivitiesPage(state)
});

const mapDispatchToProps = {
    getSpecificationActivity: HallsActionCreators.getSpecificationActivity
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SystemSpecHistory));
